window.addEventListener('load', function() {
    var swiper = new Swiper(".usb-scroller-container", {
        spaceBetween: 0,
        centeredSlides: true,
        speed: 6500,
        autoplay: {
            delay: 1,
        },
        loop: true,
        slidesPerView: 'auto',
        allowTouchMove: false,
        disableOnInteraction: true
    });
});